<template>
  <v-dialog
    v-model="show"
    :width="['md', 'sm'].includes($vuetify.breakpoint.name) ? '80%' : '50%'"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    v-if="talk != null"
  >
    <v-card style="overflow: hidden; position: relative;" :loading="isImageLoading">
      <!--EVENT WITH VIDEO-->
      <div
        v-if="
          talk.medias.video != undefined &&
          talk.medias.video != null &&
          talk.medias.video != '' &&
          talk.medias.video.match(
            /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
          )
        "
      >
        <v-card flat height="400">
          <iframe
            :id="'event-video-' + talk.id"
            height="360"
            width="100%"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            :src="talk.medias.video"
          >
          </iframe>
          <v-btn
            icon
            dark
            @click="
              stopVideo();
              show = false;
            "
            id="close-event-card"
            style="position: absolute; top: 10px; right: 10px"
          >
            <v-icon>{{ icon.mdiClose }}</v-icon>
          </v-btn>
          <share-button v-if="talk.type !== 'food'" :event="talk" />
          <register-button
            v-if="talk.type !== 'food'"
            :event="talk"
            :user="user"
            @register="register()"
            @unregister="unregister()"
          />
        </v-card>
      </div>

      <!--EVENT WITH IMAGE ONLY-->
      <div v-else-if="talk.medias.image">
        <v-card flat height="400">
          <v-img
            height="360"
            :src="imageUrl"
            :alt="talk.content[`${$i18n.locale}`].title + ' image'"
          >
            <v-row justify="end" class="ma-0">
              <v-btn
                icon
                @click="
                  stopVideo();
                  show = false;
                "
                id="close-event-card"
                ><v-icon>{{ icon.mdiClose }}</v-icon></v-btn
              >
            </v-row>
          </v-img>
          <share-button v-if="talk.type !== 'food'" :event="talk" />
          <register-button
            v-if="talk.type !== 'food'"
            :event="talk"
            :user="user"
            @register="register()"
            @unregister="unregister()"
          />
        </v-card>
      </div>
      <!--EVENT WITH NO IMAGE-->
      <!-- <div v-else>
        <v-img
          height="300"
          src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
          alt="Standard image to Events with no Image"
        >
          <v-row justify="end" class="ma-0">
            <v-btn icon @click="show = false" id="close-event-card"><v-icon>{{icon.mdiClose}}</v-icon></v-btn>
          </v-row>
        </v-img>
      </div> -->
      <div class="pa-6">
        <v-row
          v-if="
            !talk.medias.image &&
            (!talk.medias.video ||
              !talk.medias.video.match(
                /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
              ))
          "
          justify="space-between"
          class="ma-0 pb-0"
        >
          <v-col v-if="$vuetify.breakpoint.xsOnly" cols="6">
            <v-btn
              icon
              @click="
                stopVideo();
                show = false;
              "
              id="close-event-card"
              ><v-icon>{{ icon.mdiClose }}</v-icon></v-btn
            >
          </v-col>
          <v-col v-if="$vuetify.breakpoint.xsOnly" cols="6" align="end">
            <v-tooltip left v-if="talk.type !== 'food'">
              <template v-slot:activator="{ on }">
                <v-btn
                  :id="
                    (isRegistered() ? 'event-register-' : 'event-unregister-') +
                    event.id
                  "
                  icon
                  v-on="on"
                  :color="isRegistered() ? 'blue' : ''"
                  @click="isRegistered() ? unregister() : register()"
                >
                  <v-icon>{{
                    isRegistered() ? icon.mdiBookCheck : icon.mdiBookPlusOutline
                  }}</v-icon>
                </v-btn>
              </template>
              <span>{{
                $t(
                  isRegistered()
                    ? "PROGRAM.unfavorite_tooltip"
                    : "PROGRAM.favorite_tooltip"
                )
              }}</span>
            </v-tooltip>
          </v-col>

          <v-col
            :cols="$vuetify.breakpoint.xs ? 12 : 11"
            md="10"
            class="pa-0"
            style="display: flex; flex-wrap; nowrap;"
            :sm="$vuetify.breakpoint.xs ? 12 : 10"
          >
            <!-- <v-row class="ma-0 pa-0"> -->
            <v-card-title style="font-size: 28px; word-break:normal;" class="pt-0">{{
              talk.content[`${$i18n.locale}`].title
            }}</v-card-title>
            <v-tooltip
              right
              v-if="talk.type !== 'food' && !$vuetify.breakpoint.xs"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :id="
                    (isRegistered() ? 'event-register-' : 'event-unregister-') +
                    event.id
                  "
                  icon
                  v-on="on"
                  :color="isRegistered() ? 'blue' : ''"
                  @click="isRegistered() ? unregister() : register()"
                >
                  <v-icon>{{
                    isRegistered() ? icon.mdiBookCheck : icon.mdiBookPlusOutline
                  }}</v-icon>
                </v-btn>
              </template>
              <span>{{
                $t(
                  isRegistered()
                    ? "PROGRAM.unfavorite_tooltip"
                    : "PROGRAM.favorite_tooltip"
                )
              }}</span>
            </v-tooltip>
            <!-- </v-row> -->
          </v-col>

          <v-col
            v-if="!$vuetify.breakpoint.xs"
            class="pt-0"
            cols="1"
            md="2"
            sm="2"
            align="end"
          >
            <v-btn icon @click="show = false" id="close-event-card"
              ><v-icon>{{ icon.mdiClose }}</v-icon></v-btn
            >
          </v-col>
        </v-row>
        <v-card-title v-else style="font-size: 28px; word-break:normal;">{{
          talk.content[`${$i18n.locale}`].title
        }}</v-card-title>
        <v-card-text class="subtitle-1"
          >{{ $translateDate(talk.schedule.day) }}, {{ talk.schedule.start }} -
          {{ talk.schedule.end }} (GMT-3)
          <v-tooltip
            top
            v-if="
              talk.type !== 'food' &&
              !talk.medias.image &&
              (!talk.medias.video ||
                !talk.medias.video.match(
                  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
                ))
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="#4267B2"
                class="ml-1 mb-1"
                icon
                small
                v-bind="attrs"
                v-on="on"
                @click="facebookShare()"
                id="event-share-facebook-button"
              >
                <v-icon>{{ icon.mdiFacebook }}</v-icon>
              </v-btn>
            </template>
            <span>Facebook</span>
          </v-tooltip>
          <v-tooltip
            top
            v-if="
              talk.type !== 'food' &&
              !talk.medias.image &&
              (!talk.medias.video ||
                !talk.medias.video.match(
                  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
                ))
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="#1DA1F2"
                class="ml-1 mb-1"
                small
                icon
                v-bind="attrs"
                v-on="on"
                @click="twitterShare()"
                id="event-share-twitter-button"
              >
                <v-icon>{{ icon.mdiTwitter }}</v-icon>
              </v-btn>
            </template>
            <span>Twitter</span>
          </v-tooltip>
        </v-card-text>

        <v-card-text class="overline">
          <v-icon left>{{ icon.mdiMapMarker }}</v-icon>
          {{ talk.content[`${$i18n.locale}`].location }}
        </v-card-text>

        <v-card-text id="event-description" class="body-1"></v-card-text>

        <v-divider class="ml-4 mr-4" v-if="talk.type !== 'food'"></v-divider>

        <v-card-title v-if="talk.type !== 'food'">{{
          $t(`PROGRAM.event_card.speaker_types.${talk.type}`)
        }}</v-card-title>

        <v-list class="pl-2" v-if="talk.type !== 'food'">
          <speaker-avatar
            v-for="(speaker, i) in [...talk.speakers].sort((s1, s2) =>
              s1.name.toLowerCase() < s2.name.toLowerCase() ? -1 : 1
            )"
            :key="i"
            :speaker="speaker"
          />
        </v-list>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import SpeakerAvatar from "@/components/atoms/SpeakerAvatar.vue";
import RegisterButton from "@/components/atoms/event/RegisterButton.vue";
import ShareButton from "@/components/atoms/event/ShareButton.vue";
import {
  mdiShareVariant,
  mdiBookPlusOutline,
  mdiBookCheck,
  mdiClose,
  mdiMapMarker,
  mdiFacebook,
  mdiTwitter,
} from "@mdi/js";

export default {
  props: ["value", "talk"],
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    user() {
      return this.$store.state.auth.user;
    },
  },
  components: {
    SpeakerAvatar,
    RegisterButton,
    ShareButton,
  },
  data() {
    return {
      icon: {
        mdiClose,
        mdiMapMarker,
        mdiFacebook,
        mdiTwitter,
        mdiShareVariant,
        mdiBookPlusOutline,
        mdiBookCheck,
      },
      imageUrl: "",
      isImageLoading: false,
      event: {
        title: "",
        description: "",
        speakers: [],
        medias: {
          video: "",
          image: "",
        },
        schedule: {
          date: "",
          start: "",
          end: "",
        },
        location: "",
        stream: "",
      },
      relatedEvents: [
        {
          title: "How to roast potatoes with your Google Cloud Account",
          description: "",
          speakers: [""],
          medias: {
            video: "",
            image: "",
          },
          schedule: {
            date: "2020-11-12",
            start: "09:00",
            end: "11:00",
          },
          location: "Stage 4",
          stream: "",
        },
        {
          title: "How to roast potatoes with your Google Cloud Account Part 2",
          description: "",
          speakers: [""],
          medias: {
            video: "",
            image: "",
          },
          schedule: {
            date: "2020-11-12",
            start: "09:00",
            end: "11:00",
          },
          location: "Stage 4",
          stream: "",
        },
      ],
    };
  },
  methods: {
    facebookShare() {
      let request = `https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fhci2021.web.app%2Fprogram&amp;src=sdkpreparse`;
      window.open(request);
    },
    twitterShare() {
      let message = `Check out this event: "${
        this.talk.content[`${this.$i18n.locale}`].title
      }" on the`;
      let url = `${window.location.origin}${this.$route.path}`;
      let hashtags = `jornadasHCI`;
      let request = `http://twitter.com/share?text=${message}&url=${url}&hashtags=${hashtags}`;
      window.open(request);
    },
    async setImageUrl(id) {
      this.imageUrl = await this.$store.dispatch("getEventImage", {
        name: id,
      });
      this.isImageLoading = false;
    },
    isRegistered() {
      return Object.keys(this.user?.events || {}).includes(this.talk.id);
    },
    register() {
      this.$emit("register", this.talk);
    },
    unregister() {
      this.$emit("unregister", this.talk);
    },
    stopVideo() {
      const iframe = document.getElementById("event-video-" + this.talk.id);

      if (iframe) {
        const aux = iframe.src;
        iframe.src = "";
        iframe.src = aux;
      }
    }
  },
  mounted() {
    const eventDescEl = document.getElementById('event-description');
  
    if (eventDescEl && this.talk) {
      eventDescEl.innerHTML = this.talk.content[`${this.$i18n.locale}`].description;
    }

    if (this.talk && this.talk.medias.image) {
      this.isImageLoading = true;
      this.setImageUrl(this.talk.id);
    }
  }
};
</script>

<style scoped>
.padding-row {
  margin: -20px;
  margin-bottom: -30px;
}

.div-wrap {
  width: 650px;
  word-wrap: break-word;
}

.share-title {
  font-size: 19px;
  font-weight: 300;
}
</style>
